import React from "react";
import { useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Wrapper from "../atoms/Wrapper";
import { post_report, set_report_state } from "../../actions/report";
import { useDispatch } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

const H1 = styled.h1`
  font-weight: 400;
  font-size: 1.1rem;
  color: ${props => props.theme.colors.black};
  margin: 1.5rem 0;
`;
const StyledWrapper = styled(Paper)`
  overflow: scroll;
  width: 40rem;
  height: fit-content;
  max-width: calc(100vw - 2rem);
  max-height: 100vh;
  padding: 1.5rem 2rem;
  box-sizing: border-box;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const StyledForm = styled.form`
  width: 100%;
  max-height: 70vh;
`;
const StyledTextField = styled(TextField)`
  width: 100%;
`;
const TextFieldWrapper = styled(Wrapper)`
  margin: 1rem 0;
  width: 100%;
`;

const SubmitButtonWrapper = styled(Wrapper)`
  width: 100%;
  margin-top: 1.2rem;
  margin-bottom: 0.4rem;
  position: relative;
`;

const CircularWrapper = styled(Wrapper)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const TextWrapper = styled(Wrapper)`
  margin-bottom: 1.2rem;
`;

const ReportForm = props => {
  const [value, setValue] = React.useState({
    message: ""
  });
  const dispatch = useDispatch();
  const handleMessageChange = e => {
    setValue({ ...value, message: e.target.value });
  };

  React.useEffect(() => {
    return () => dispatch(set_report_state("sleep"));
  }, [dispatch]);

  const { state } = useSelector(state => state.report);

  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }
    dispatch(post_report(value.message, props.type));
  };

  return (
    <StyledWrapper>
      <H1>{props.type}報告</H1>
      {state === "success" ? (
        <TextWrapper>報告を送信しました。</TextWrapper>
      ) : (
        <StyledForm onSubmit={handleSubmit}>
          <TextFieldWrapper>
            <FormControl style={{ width: "100%" }}>
              <StyledTextField
                label="報告内容"
                value={value.message}
                onChange={handleMessageChange}
                variant="outlined"
                required
                multiline
                rows={4}
                inputProps={{ maxLength: 255 }}
              />
              <FormHelperText>{value.message.length} / 255</FormHelperText>
            </FormControl>
          </TextFieldWrapper>
          <SubmitButtonWrapper>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={state === "request"}
            >
              送信
            </Button>
            {state === "request" && (
              <CircularWrapper>
                <CircularProgress />
              </CircularWrapper>
            )}
          </SubmitButtonWrapper>
        </StyledForm>
      )}
    </StyledWrapper>
  );
};

export default ReportForm;
